<div class="version-container">
  {{version}}
</div>
<div class="environment-container" *ngIf="isHidden" (click)="onShow()">
  <h5>{{apiName ? apiName : "Selecione o ambiente"}}</h5>
</div>
<div id="overlay" [hidden]="isHidden" (click)="onShow()"></div>
<div class="boxList mt-0" [hidden]="isHidden">
  <h4>Selecione um ambiente de desenvolvimento</h4>
  <ul class="p-0 mb-0">
    <li *ngFor="let item of chave">
      <button (click)="setEnvironment(item)">{{item}}</button>
    </li>
    <li>
      <button>
        <span class="material-icons align-middle">file_upload</span>
        Ver logs da API
      </button>
    </li>
   </ul>
   <button (click)="onShow()">Cancelar</button>
</div>